import { cn } from '@neo/lib/utils'
import { Tooltip } from '@neo/primitives/tooltip'
import {
  CircleCheck,
  Layers,
  Lock,
  MessageCircle,
  MessageSquare,
  Phone,
  ScrollText,
  Send,
  Slack,
  StickyNote,
} from 'lucide-react'
import { AdhocChannels, ConvChannels } from 'v2/types/api/conversations'
import { ChunkType } from 'v2/types/chunk.internal'

interface ChannelIconProps {
  channel: ConvChannels | ChunkType | AdhocChannels
  className?: string
}

const iconMap = {
  [ConvChannels.CHAT]: MessageSquare,
  [ConvChannels.WHATSAPP]: Send,
  [ChunkType.notes]: StickyNote,
  [ChunkType.disposition]: ScrollText,
  [ConvChannels.MESSAGE]: MessageCircle,
  [ConvChannels.OMNI]: Layers,
  [ConvChannels.CALL]: Phone,
  [AdhocChannels.PRIVATE_CHAT]: Lock,
  [AdhocChannels.TASK]: CircleCheck,
  [ConvChannels.SLACK]: Slack,
}

const tooltipContentMap = {
  [ConvChannels.CHAT]: 'Chat message',
  [ChunkType.notes]: 'Note message',
  [ChunkType.disposition]: 'Disposition',
  [ConvChannels.MESSAGE]: 'SMS message',
  [ConvChannels.WHATSAPP]: 'WhatsApp message',
  [ConvChannels.OMNI]: 'Omni-channel message',
  [ConvChannels.CALL]: 'Call',
  [AdhocChannels.PRIVATE_CHAT]: 'Internal chat',
  [AdhocChannels.TASK]: 'Task',
}

export const ChannelIcon = ({ channel, className }: ChannelIconProps) => {
  const IconComponent = iconMap[channel as keyof typeof iconMap]
  const tooltipContent = tooltipContentMap[channel as keyof typeof tooltipContentMap]
  if (!IconComponent) return null

  return (
    <Tooltip content={tooltipContent}>
      <span>
        <IconComponent className={cn('size-3 text-brand-text', className)} />
      </span>
    </Tooltip>
  )
}
